import React from "react";
import styles from "./showinfo.module.css";
import Header from "./Header";

import Umbrella from "../components/Umbrella";
import brain from "../static/images/component_svg/brain.svg";
import digitalBackward from "../static/images/component_svg/digiBackward.svg";
import cube from "../static/images/component_svg/cube.svg";
import wisdom from "../static/images/component_svg/wisdom.svg"

function ShowInfo() {
  return (
    <div>
      <div className={styles.main}>
        <div className={styles.body}>
          <Header gameNameTH="เกมทดสอบทักษะสมอง"/>
          <div className={styles.picbody}>
            <div className={styles.picgroup}>
              <div className={styles.pic}>{<Umbrella color="#F36621" />}</div>
              <div className={styles.pic}>
                {<img src={brain} alt="brain" />}
              </div>
            </div>
            <div className={styles.picgroup}>
              <div className={styles.pic}>
                {<img src={digitalBackward} alt="digiBackward" />}
              </div>
            </div>
            <div className={styles.picgroup}>
              <div className={styles.pic}>{<img src={cube} alt="cube" />}</div>
              <div className={styles.pic}>{<img src={wisdom} alt="wisdom" />}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ShowInfo;
